import clsx from "clsx";
import { useEffect, useState } from "react";

import {
  subscribeBoardSaveStatus,
  type BoardSaveStatusState,
} from "../data/BoardStorage";

import "./BoardSaveStatus.scss";

const SAVED_VISIBLE_MS = 2200;

export const BoardSaveStatus = () => {
  const [status, setStatus] = useState<BoardSaveStatusState>({ state: "idle" });
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let hideTimer: number | undefined;
    return subscribeBoardSaveStatus((next) => {
      window.clearTimeout(hideTimer);
      setStatus(next);
      if (next.state === "idle") {
        setVisible(false);
        return;
      }
      setVisible(true);
      if (next.state === "saved") {
        hideTimer = window.setTimeout(() => {
          setVisible(false);
          setStatus({ state: "idle" });
        }, SAVED_VISIBLE_MS);
      }
    });
  }, []);

  if (!visible || status.state === "idle") {
    return null;
  }

  let label = "";
  if (status.state === "saving") {
    label = status.manual ? "正在保存…" : "自动保存中…";
  } else if (status.state === "saved") {
    label = status.manual ? "已保存" : "已自动保存";
  } else if (status.state === "error") {
    label = `保存失败：${status.message}`;
  }

  return (
    <div
      className={clsx("board-save-status", {
        "board-save-status--saving": status.state === "saving",
        "board-save-status--saved": status.state === "saved",
        "board-save-status--error": status.state === "error",
      })}
      role="status"
      aria-live="polite"
    >
      {status.state === "saving" && (
        <span className="board-save-status__spinner" aria-hidden />
      )}
      <span>{label}</span>
    </div>
  );
};
